import { authenticatedApiRequest } from "./core";
import type { PaginatedRoyaltyStatementsResponse } from "./revenue";
import type { RoyaltyStatement } from "@/types";

// Payee portal endpoints. Scoped server-side by the user's payee access, not by
// organization, so these never take a label_id.
export interface PortalRoyaltyStatementQueryParams {
  payees?: string;
  page?: number;
  page_size?: number;
  ordering?: string;
}

const toQuery = (params: object) =>
  new URLSearchParams(
    Object.entries(params).filter(([, v]) => v != null && v !== "") as [string, string][],
  ).toString();

export const portalApi = {
  getRoyaltyStatements: async (
    params: PortalRoyaltyStatementQueryParams,
  ): Promise<PaginatedRoyaltyStatementsResponse> => {
    const query = toQuery(params);
    return authenticatedApiRequest<PaginatedRoyaltyStatementsResponse>(
      `/portal/royalty-statements${query ? `?${query}` : ""}`,
    );
  },
  getRoyaltyStatement: async (id: string): Promise<RoyaltyStatement> => {
    return authenticatedApiRequest<RoyaltyStatement>(`/portal/royalty-statements/${id}`);
  },
  getRoyaltyStatementHtml: async (id: string): Promise<{ html: string | null }> => {
    return authenticatedApiRequest<{ html: string | null }>(
      `/portal/royalty-statements/${id}/html`,
    );
  },
};
